import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import React from "react";

const CONTACT_EMAIL = "CEDAR@mail.nissan.co.jp";

export const ContactUsCard = () => (
  <div className="cedar_home_contact_card" data-test-id="cedar-home-contact-card">
    <div className="cedar_home_contact_card_icon">
      <SupportAgentOutlinedIcon fontSize="large" />
    </div>
    <div className="cedar_home_contact_card_body">
      <h2 className="cedar_home_contact_card_title">CONTACT US</h2>
      <p className="cedar_home_contact_card_text">
        Hello, Welcome to CEDAR! If you have any questions or require assistance, please reach out to us and we will respond as quickly as
        possible.
      </p>
      <a className="cedar_home_contact_card_button" href={`mailto:${CONTACT_EMAIL}`} data-test-id="cedar-home-contact-mailto">
        <MailOutlineIcon fontSize="small" />
        {CONTACT_EMAIL}
      </a>
    </div>
  </div>
);
